// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_nl-0";